import { AppCookieService } from '@ace/ace';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService implements CanActivate{

  constructor(private router:Router,private cookieService: AppCookieService){
  }
  canActivate(){
    const logintoken = this.cookieService.getCookie('accessToken') || '';

    if (logintoken) {
      return true;
    }else{
      this.router.navigate(['login']);
      return false;
    }

  }
}
